// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html,
body,
#root {
  height: 100%;
}
:root {
  --adm-color-primary: #1677ff;
  --adm-color-success: #00b578;
  --adm-color-warning: #ff8f1f;
  --adm-color-danger: #ff3141;
  --adm-color-white: #ffffff;
  --adm-color-text: #333333;
  --adm-color-text-secondary: #666666;
  --adm-color-weak: #999999;
  --adm-color-light: #cccccc;
  --adm-color-border: #eeeeee;
  --adm-color-box: #f5f5f5;
  --adm-color-background: #ffffff;
  --adm-font-size-main: var(--adm-font-size-5);
  --adm-font-family: -apple-system, blinkmacsystemfont, 'Helvetica Neue', helvetica, segoe ui, arial, roboto, 'PingFang SC', 'miui', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/styles.less"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,SAAA;EACA,sBAAA;AACJ;AAEA;;;EAGI,YAAA;AAAJ;AAGA;EACI,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,2BAAA;EAEA,0BAAA;EACA,yBAAA;EACA,mCAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,wBAAA;EACA,+BAAA;EAEA,4CAAA;EAEA,oLAAA;AAJJ","sourcesContent":["* {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n    height: 100%;\n}\n\n:root {\n    --adm-color-primary: #1677ff;\n    --adm-color-success: #00b578;\n    --adm-color-warning: #ff8f1f;\n    --adm-color-danger: #ff3141;\n\n    --adm-color-white: #ffffff;\n    --adm-color-text: #333333;\n    --adm-color-text-secondary: #666666;\n    --adm-color-weak: #999999;\n    --adm-color-light: #cccccc;\n    --adm-color-border: #eeeeee;\n    --adm-color-box: #f5f5f5;\n    --adm-color-background: #ffffff;\n\n    --adm-font-size-main: var(--adm-font-size-5);\n\n    --adm-font-family: -apple-system, blinkmacsystemfont, 'Helvetica Neue',\n        helvetica, segoe ui, arial, roboto, 'PingFang SC', 'miui',\n        'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
